export default __webpack_public_path__ + "static/media/ZipLogo-OnLight.336bfe2f.svg";